const LoginButton = (props) => {
	return (
		<div className="rounded-2xl h-fit w-fit pl-4 pr-4 pt-2 pb-2 border-2 border-white text-white text-xl font-extrabold cursor-pointer select-none hover:opacity-[85%]" {...props}>
			LOGIN
		</div>
	)
}

export default LoginButton